import api from '@/services/gateway/api';

const state = {
  list: [],
  meta: { current_page: 1, per_page: 15, total: 0, last_page: 1 },
  phrase: null
};

const getters = {
  getList: state => state.list,
  getMeta: state => state.meta,
  getPhrase: state => state.phrase
};

const mutations = {
  setList (state, list) {
    state.list = list;
  },
  setMeta (state, meta) {
    state.meta = meta;
  },
  setPhrase (state, data) {
    state.phrase = data.data;
  }
};

const actions = {
  actionGetPhrases ({ commit }, { params, isLatest = () => true }) {
    return api.get('camp/phrases', { params }).then(({ data }) => {
      if (isLatest()) {
        commit('setList', data.data);
        commit('setMeta', data.meta);
      }
      return data;
    });
  },
  actionAddPhrase ({ commit }, payload) {
    return api.post('camp/phrases', payload);
  },
  actionEditPhrase ({ commit }, payload) {
    payload['_method'] = 'PATCH';
    return api.post('camp/phrases/' + payload.id, payload);
  },
  actionRemovePhrase ({ commit }, payload) {
    payload['_method'] = 'DELETE';
    return api.post('camp/phrases/' + payload.id, payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
